"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var context = _react.default.createContext({
  _handleUpdate: function _handleUpdate() {
    return 0;
  },
  _setTarget: function _setTarget() {
    return 0;
  }
});

context.displayName = 'ScrollToBottomInternalContext';
var _default = context;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9TY3JvbGxUb0JvdHRvbS9JbnRlcm5hbENvbnRleHQuanMiXSwibmFtZXMiOlsiY29udGV4dCIsIlJlYWN0IiwiY3JlYXRlQ29udGV4dCIsIl9oYW5kbGVVcGRhdGUiLCJfc2V0VGFyZ2V0IiwiZGlzcGxheU5hbWUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVBLElBQU1BLE9BQU8sR0FBR0MsZUFBTUMsYUFBTixDQUFvQjtBQUNsQ0MsRUFBQUEsYUFBYSxFQUFFO0FBQUEsV0FBTSxDQUFOO0FBQUEsR0FEbUI7QUFFbENDLEVBQUFBLFVBQVUsRUFBRTtBQUFBLFdBQU0sQ0FBTjtBQUFBO0FBRnNCLENBQXBCLENBQWhCOztBQUtBSixPQUFPLENBQUNLLFdBQVIsR0FBc0IsK0JBQXRCO2VBRWVMLE8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5jb25zdCBjb250ZXh0ID0gUmVhY3QuY3JlYXRlQ29udGV4dCh7XG4gIF9oYW5kbGVVcGRhdGU6ICgpID0+IDAsXG4gIF9zZXRUYXJnZXQ6ICgpID0+IDBcbn0pO1xuXG5jb250ZXh0LmRpc3BsYXlOYW1lID0gJ1Njcm9sbFRvQm90dG9tSW50ZXJuYWxDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgY29udGV4dDtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scroll-to-bottom/lib/ScrollToBottom/InternalContext.js
// module id = 509
// module chunks = 0